import type { ThemeOptions } from '@mui/material';

import { black, blue, gray, green, purple, red, white, yellow } from '~/styles/colors';

declare module '@mui/material/styles' {
  interface PaletteOptions {
    link?: {
      main?: string;
    };
  }

  interface Palette {
    link: {
      main: string;
    };
  }
}

const PaletteTheme: Partial<ThemeOptions> = {
  palette: {
    background: {
      default: gray[50],
    },
    error: {
      contrastText: white,
      dark: red[500],
      light: red.A50,
      main: red[500],
    },
    info: {
      contrastText: white,
      dark: purple[900],
      light: purple.A50,
      main: purple[500],
    },
    primary: {
      contrastText: white,
      dark: black[1000],
      light: black[100],
      main: black[1000],
    },
    secondary: {
      contrastText: gray[800],
      dark: gray[600],
      light: gray[100],
      main: gray[600],
    },
    success: {
      contrastText: white,
      dark: green[900],
      light: green.A50,
      main: green[900],
    },
    warning: {
      contrastText: black[1000],
      dark: yellow[900],
      light: yellow.A50,
      main: yellow[500],
    },
    link: {
      main: blue[500],
    },
  },
};

export default PaletteTheme;
